import React, { useEffect, useState } from "react";
import axios from "../../utils/AxiosInstance";
import { Spinner, Button } from "react-bootstrap";
import { FaRedo, FaSearch } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CarBooking = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const token = localStorage.getItem("token");
  console.log(statusFilter);

  const fetchBookings = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `/admin/booking/all-bookings?page=${page}&limit=${limit}&search=${search}&status=${statusFilter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(res);
      if (res.status === 200) {
        setBookings(res.data.data.bookings);
        setTotalPages(res.data.data.pagination.totalPages || 1);
      }

      // toast.success(res.data.message);
    } catch (err) {
      console.error("Error:", err);
      toast.error("Error fetching bookings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [page, search, statusFilter]);

  const handleReset = () => {
    setSearch("");
    setStatusFilter("");
    setPage(1);
  };

  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push("...");
    for (
      let i = Math.max(2, page - 1);
      i <= Math.min(totalPages - 1, page + 1);
      i++
    )
      pages.push(i);
    if (page < totalPages - 2) pages.push("...");
    pages.push(totalPages);
  }

  return (
    <div className="container mt-4">
      <h4 className="text-center mb-4">Admin Panel - Booking Management</h4>

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div className="d-flex gap-2">
          <input
            type="text"
            placeholder="Search by a car"
            className="form-control"
            style={{ width: "250px" }}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />

          <Button variant="warning" onClick={handleReset}>
            <FaRedo/>
          </Button>

          <select
            className="form-select"
            style={{ width: "180px" }}
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
            <option value="rescheduled">Rescheduled</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" />
        </div>
      ) : bookings.length === 0 ? (
        <p className="text-center">No bookings found.</p>
      ) : (
        <table className="table table-bordered">
          <thead className="table-dark">
            <tr>
              <th>No</th>
              <th>Booking No</th>
              <th>Car</th>
              <th>Buyer</th>
              <th>Date</th>
              <th>Time Slot</th>
              <th>Status</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((b, index) => (
              <tr key={b._id}>
                <td>{(page - 1) * limit + index + 1}</td>
                <td>{b.bookingNo}</td>
                <td>{b.car?.title || "N/A"}</td>
                <td>{b.buyer?.name || "N/A"}</td>
                <td>{new Date(b.scheduledDate).toLocaleDateString()}</td>
                <td>{b.timeSlot}</td>
                <td>{b.status}</td>
                <td>{b.bookingType}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Pagination */}
      <div className="d-flex justify-content-center gap-2 my-4">
        <button
          className="btn btn-success"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Prev
        </button>
        {pages.map((pg, i) => (
          <button
            key={i}
            className={`btn ${
              pg === page
                ? "btn-dark"
                : pg === "..."
                ? "btn-secondary"
                : "btn-light"
            }`}
            disabled={pg === "..."}
            onClick={() => typeof pg === "number" && setPage(pg)}
          >
            {pg}
          </button>
        ))}
        <button
          className="btn btn-success"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};
export default CarBooking;
